import { c as _c } from "react/compiler-runtime";
interface NavigationItem {
  id: string;
  title: string;
  type: string;
}
interface CustomerCareNavigationProps {
  items: NavigationItem[];
  activeSection: string;
  onSectionClick: (sectionId: string) => void;
}
const CustomerCareNavigation = t0 => {
  const $ = _c(9);
  const {
    items,
    activeSection,
    onSectionClick
  } = t0;
  let t1;
  if ($[0] !== activeSection || $[1] !== items || $[2] !== onSectionClick) {
    let t2;
    if ($[4] !== activeSection || $[5] !== onSectionClick) {
      t2 = item => <li key={item.id} className="h-15 flex cursor-pointer items-center border border-l-0 border-r-0 border-t-0 border-[#e9e9e9] py-4 pr-5 last:!border-b-0"><a href={`#${item.id}`} className={`pl-3 text-[16px] font-medium ${activeSection === item.id ? "rounded border-l-4 border-[#069590]" : "border-l-0"}`} onClick={e => {
          e.preventDefault();
          onSectionClick(item.id);
        }}>{item.title}</a></li>;
      $[4] = activeSection;
      $[5] = onSectionClick;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = items.map(t2);
    $[0] = activeSection;
    $[1] = items;
    $[2] = onSectionClick;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <><aside className="sticky top-5 hidden rounded-lg bg-white shadow-[5px_6px_20px_rgba(0,0,0,0.07)] lg:block" aria-label="Customer care navigation"><nav className="sticky top-5 hidden rounded-lg bg-white shadow-[5px_6px_20px_rgba(0,0,0,0.07)] lg:block"><ul>{t1}</ul></nav></aside></>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
export default CustomerCareNavigation;